import cx from 'classnames';
import { t } from 'i18next';

const ROLE_LABELS: any = {
  dps: 'recruitment:roles.any-dps',
  tank: 'recruitment:roles.tank',
  healer: 'recruitment:roles.healer',
  'dps-melee': 'recruitment:roles.melee-dps',
  'dps-ranged': 'recruitment:roles.ranged-dps'
};

function DefaultRoleCombinedSlotComponent(props: any) {
  const { role, rolePriorities } = props;

  return (
    <div className="d-inline-block slds-m-horizontal--x-small">
      <div>
        <span className="slds-avatar slds-avatar--small slds-m-around--xx-small" style={{ border: '1px solid #333' }}>
          <span className={cx('icon-role icon-22px', `${role}-rio`)} />
        </span>
      </div>
      <div
        className="slds-p-vertical--xx-small slds-p-horizontal--x-small text-bold"
        style={{
          position: 'relative',
          backgroundColor: '#404040',
          borderRadius: '0.25rem'
        }}
      >
        {t(ROLE_LABELS[role])}

        {rolePriorities[role] === 2 && (
          <i
            className="fa fa-fw fa-circle-arrow-up rio-text-shadow--heavy"
            style={{ fontSize: 12, color: '#ff8000', position: 'absolute', right: -2, top: -1 }}
          />
        )}
      </div>
    </div>
  );
}
export default DefaultRoleCombinedSlotComponent;
